module.exports = __webpack_public_path__ + "static/media/deaf.80f24507.svg";